<template>
  <div id="list-menus">
    <TitleComponent />
    <div class="d-lg-flex">
      <div class="col-lg-3 p-1">
        <div class="card mt-3 p-3">
          <div class="card-body">
            <div class="mb-2">
              <label for="exampleFormControlInput1">Nama</label>
              <input
                type="text"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="Nama lengkap"
              />
            </div>
            <div class="mb-2">
              <label for="exampleFormControlInput2">Icon</label>
              <input
                type="text"
                class="form-control"
                id="exampleFormControlInput2"
                placeholder="Username"
              />
            </div>
            <div class="mb-2">
              <label for="exampleFormControlInput3">Color</label>
              <input
                type="color"
                class="form-control form-control-color"
                id="exampleColorInput"
                value="#563d7c"
                title="Choose your color"
              />
            </div>
            <div class="mb-2">
              <label for="exampleFormControlInput4">Ref</label>
              <input
                type="text"
                class="form-control"
                id="exampleFormControlInput4"
                placeholder="Level"
              />
            </div>
            <div class="mb-2">
              <label for="exampleFormControlInput4">Dropdown</label>
              <input
                type="text"
                class="form-control"
                id="exampleFormControlInput4"
                placeholder="Level"
              />
            </div>
            <div class="mb-2">
              <label for="exampleFormControlInput4">Url</label>
              <input
                type="text"
                class="form-control"
                id="exampleFormControlInput4"
                placeholder="Level"
              />
            </div>
            <div class="mb-2 text-end">
              <button type="button" class="btn btn-danger btn-sm m-1">
                <i class="fa-solid fa-circle-xmark"></i> Cancel
              </button>
              <button type="button" class="btn btn-primary btn-sm m-1">
                <i class="fa-solid fa-circle-plus"></i> Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col p-1">
        <div class="card mt-3 p-3">
          <div class="card-body">
            <div class="d-lg-flex d-md-flex">
              <div class="p-1">
                <label for="exampleFormControlInput1">Search</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Search here"
                />
              </div>
            </div>
            <div class="table-container mt-2">
              <div class="table-wrapper">
                <table class="table table-sm table-hover table-bordered">
                  <thead>
                    <tr>
                      <th width="50">No</th>
                      <th width="100">Nama</th>
                      <th width="100">Icon</th>
                      <th width="100">Color</th>
                      <th width="100">Ref</th>
                      <th width="100">Dropdown</th>
                      <th width="100">Url</th>
                      <th width="100" class="fixed-col">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td class="fixed-col">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <div class="icon-card">
                            <i class="fas fa-edit icon"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="table-footer mt-2 d-lg-flex d-md-flex justify-content-between align-items-center"
            >
              <div
                class="d-flex col justify-content-lg-start justify-content-md-start justify-content-center mb-2 mb-lg-0 mb-sm-0 mb-md-0"
              >
                <div class="dataperpage me-2">
                  <p><i class="fas fa-eye me-2"></i>Perpage : 10</p>
                </div>
                <div class="totaldata">
                  <p><i class="fas fa-database me-2"></i>203.021</p>
                </div>
              </div>
              <div
                class="col d-flex justify-content-lg-end justify-content-md-end justify-content-center"
              >
                <PaginationComponent />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/PaginationComponent.vue";
import TitleComponent from "@/components/TitleComponent.vue";

export default {
  name: "MenuView",
  components: {
    TitleComponent,
    PaginationComponent,
  },
};
</script>
<style scoped>
/* SHOW PERPAGE & TOTAL DATA */
.table-footer .dataperpage p,
.table-footer .totaldata p {
  font-size: 12px;
  padding: 5px 8px !important;
  border-radius: 3px;
  border: 1px solid var(--border-one);
}
</style>
